import { Button, Dialog, Grid, Typography, useMediaQuery } from '@mui/material';
import React from 'react';
import { useTheme } from '@mui/material/styles';
import { OrangePendingwarning } from 'component/BuyersMarketplace/Marketplaceicons';
import { flagDueDelligenceFile, getDueDelligenceFile } from 'api/apiService';
import Swal from 'sweetalert2';

const ConfirmDueDiligence = ({
  open,
  getBuyerIndividualValue,
  ApicallDueDiligence,
  groupCall,
  data,
  SetOpenConfirmDueDiligence,
}) => {
  const address =
    getBuyerIndividualValue?.PropertyDetails?.propertyAddress?.streetName;

  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches900 = useMediaQuery(theme.breakpoints.down(900));
  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          borderRadius: '5px',
          width: '100%',
        },
      }}
    >
      <Grid
        container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: matches900 ? '20px' : '30px',
          gap: '20px',
        }}
      >
        <Grid item>
          <Typography
            sx={{
              fontFamily: 'poppins',
              fontWeight: 400,
              fontSize: matchessm ? '10px' : '14px',
              color: '#666666',
            }}
          >
            {address}
          </Typography>
        </Grid>
        <Grid item sx={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
          <OrangePendingwarning matches700={matches700} />
          <Typography
            sx={{
              fontFamily: 'poppins',
              fontWeight: 400,
              fontSize: matchessm ? '16px' : '24px',
            }}
          >
            Mark as Complete
          </Typography>
        </Grid>
        <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography
            sx={{
              fontFamily: 'poppins',
              fontWeight: 400,
              fontSize: matchessm ? '12px' : '16px',
              color: '#666666',
            }}
          >
            Are you sure you want to mark the due diligence as reviewed?
          </Typography>
        </Grid>
      </Grid>

      <Grid
        item
        container
        sx={{
          padding: matches900 ? '20px' : '30px',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          gap: '30px',
        }}
      >
        <Grid item>
          <Button
            variant="outlined"
            style={{
              padding: matchessm ? '6px 23px' : '10px 39px',
              width: '100%',
              height: matchessm ? '35px' : '41px',
              fontSize: matchessm ? '12px' : '15px',
              color: '#666666',
              fontWeight: '400',
              fontFamily: 'Poppins',
              border: '1px solid rgba(17, 35, 71, 0.1)',
              borderRadius: '5px',
              textTransform: 'none',
            }}
            onClick={() => {
              SetOpenConfirmDueDiligence(false);
            }}
          >
            Cancel
          </Button>
        </Grid>
        <Grid item>
          <Button
            onClick={() => {
              flagDueDelligenceFile(data?.StrataLink?.propertyId, null).then(
                (res) => {
                  if (res.status == 1) {
                    Swal.fire({
                      title: res.heading,
                      text: res.message,
                      icon: res.status === 1 ? 'success' : 'error',
                      confirmButtonText: 'Close',
                    });
                    SetOpenConfirmDueDiligence(false);
                  }
                  getDueDelligenceFile(data?.StrataLink?.propertyId);
                  groupCall();
                  ApicallDueDiligence();
                }
              );
            }}
            variant="outlined"
            style={{
              padding: matchessm ? '6px 25px' : '10px 35px',
              width: '100%',
              height: matchessm ? '35px' : '41px',
              fontSize: matchessm ? '12px' : '15px',
              color: '#FFFFFF',
              fontWeight: '400',
              fontFamily: 'Poppins',
              background: '#4CA4D6',
              borderRadius: '5px',
              textTransform: 'none',
            }}
          >
            Confirm
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default ConfirmDueDiligence;
